import ReactGA from "react-ga";
import moment from "moment";
import { useDispatch } from "react-redux";
import { setTrackEvent } from "../store/analytics";
import { events } from "./config";

const useGAEventTracker = (category = "Category") => {

  const dispatch = useDispatch();
  const trackEvent = (action = "action", label = "label") => {
    if (window.dynamicReview) return
    dispatch(
      setTrackEvent({
        category: parseCategory(category, label),
        created_at: moment(Date.now()).unix(),
      })
    );
    ReactGA.event({
      category,
      action,
      label,
    });
  };

  return trackEvent;
};

function parseCategory(category, label) {
  switch (category) {
    case events.marketing.category:
      let indexOfAss = label.charAt(label.length - 1);
      return `marketing_${indexOfAss}`;
    case events.productRecommend.category:
      return `product_recommend`;
    case events.socialAccount.category:
      return `social_account`;
    default:
      break;
  }
}

export default useGAEventTracker;
